/**
 * JSON Schema for the network object.
 *
 * http://json-schema.org/
 */
export default {
  id: "/Network",
  type: "object",
  properties: {
    connectionType: { type: "string" },
    publicIp: { type: "string" },
    country: { type: "string" }
  },
  required: ["country"]
};
